import { useEffect } from "react";
import { IWeeklyReports } from "../../../../models/dashboard/staffReports/staffReports";
import { IReport, IReports } from "../../../../models/master/reports";
import { limit, pageBlockId } from "../../../../constants/pageBlocks";
import { ReportFrequency } from "../../../../models/dashboard/adminDashboard";
import { connect, useDispatch } from "react-redux";
import { setReportsMonthly } from "../../../../store/slices/master/reportSlice";
import { getReports } from "../../../../action/masters/reportActionCreator";
import { baseURL } from "../../../../constants/commonConstants";
import { useNavigate } from "react-router-dom";
import { ROUTER_URL } from "../../../../constants/routerUrl";
import { getPageBlockData } from "../../../../common-functions/commonFunctions";

const StaffWeeklyReports = (props: IWeeklyReports) => {
  const { getWeeklyReports, weeklyReports, snapShots } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const handleViewALL = () => {
    navigate(ROUTER_URL.STAFF_ALL_WEEKLY_REPORTS);
  };

  const pageBlockData = getPageBlockData(
    snapShots,
    pageBlockId.reportResources
  );

  useEffect(() => {
    if (pageBlockData?.displayOrNot) {
      getWeeklyReports(
        pageBlockId.reportResources,
        limit.three,
        ReportFrequency.Monthly
      );
    }
  }, [pageBlockData]);

  useEffect(() => {
    return () => {
      dispatch(setReportsMonthly([]));
    };
  }, []);

  return (
    <>
      <div className="col-lg-12 mt-3">
        <div
          className={
            pageBlockData?.displayOrNot
              ? "card-wrap"
              : "card-wrap card-snapshot"
          }
          style={
            pageBlockData?.displayOrNot === false
              ? { backgroundImage: `url(${baseURL + pageBlockData.image})` }
              : {}
          }
        >
          <div className="title">
            <h2>Weekly Report</h2>
            <a
              onClick={handleViewALL}
              className={
                pageBlockData?.displayOrNot ? "btn-link" : "btn-link d-none"
              }
              title="View All Weekly Reports"
            >
              View All
            </a>
          </div>
          <div className="acc-resource mt-3 row">
            {weeklyReports?.map((report: IReports) => (
              <div className="col-lg-4" key={report.id}>
                <a href={report.url} target="_blank">
                  <div className="card d-flex align-items-start flex-column">
                    <div className="reportimg">
                      <img src={baseURL + report.icon} alt="" />
                    </div>
                    <h2 className="para-hide-1">{report.name}</h2>
                    <p className="para-hide-2">{report.description}</p>
                  </div>
                </a>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

const mapDispatchToProps = {
  getWeeklyReports: (
    pageBlockId: number,
    noOfItems: number,
    ReportFrequency: number
  ) => getReports(undefined, pageBlockId, noOfItems, ReportFrequency),
};

function mapStateToProps(state: any) {
  return {
    weeklyReports: state.report.monthlyreports,
    snapShots: state.snapShot.snapShots,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(StaffWeeklyReports);
